import { getUrl, Request } from "../../request";

export const getUserCars = () => {
  return Request.get(getUrl("/api/v1/cars/user-car/"));
};

export const deleteUserCar = (user_car_id) => {
  return Request.del(getUrl(`/api/v1/cars/user-car/${user_car_id}`));
};

export const getCarsBrands = (type) => {
  return Request.get(getUrl("/api/v1/cars/load_cars_brand/"), {
    type,
  });
};

export const getCarsModels = (brand_id) => {
  return Request.get(getUrl("/api/v1/cars/load-cars/"), {
    brand_id,
  });
};

export const postUserCar = (model_id, year = null, mobile_number = null) => {
  return Request.post(getUrl("/api/v1/cars/set-car/"), {
    model_id,
    year,
    mobile_number,
  });
};

export const putUserCar = (
  user_car_id,
  year
) => {
  return Request.put(getUrl("/api/v1/cars/set-car/"), {
    user_car_id,
    year,
  });
};

export const getTypes = () => {
  return Request.get(getUrl("/api/v1/cars/load-brand-type/"));
};

export const getBrands = (type_id) => {
  return Request.get(getUrl("/api/v1/cars/load-brand-type/"), {
    type_id,
  });
};
